import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
	const { pathname, search } = useLocation();

	useEffect(() => {
		// Ensure the viewport resets to the top on every page transition
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
	}, [pathname, search]);

	return null;
};

export default ScrollToTop;
